import React, { Component } from 'react'
import { connect } from 'react-redux'
import lscache from 'lscache'

import LoadingSpinner from './LoadingSpinner'
import ErrorMessage from './ErrorMessage'
import KeywordList from './KeywordList'
import Toggle from './Toggle'
import { fetch } from '../utils/fetch'
import { ENDPOINT_KEYWORD_GRAPH } from '../constants'

const CACHE_KEY_SORT = 'sort-keywords'

export const COLORS = [
  [140, 152, 210],
  [154, 187, 221],
  [169, 224, 234],
  [216, 238, 233],
  [181, 238, 225]
]

class GroupedKeywords extends Component {
  state = {
    groups: null,
    sortByFrequency: lscache.get(CACHE_KEY_SORT)
  }
  componentDidMount () {
    if (!this.state.groups) {
      this.fetchGroups()
    }
  }
  fetchGroups = () => {
    this.props.fetchGroups().then(
      groups => this.setState({ groups }),
      error => this.setState({ error }))
  }
  toggleSort = () => {
    this.setState({ sortByFrequency: !this.state.sortByFrequency })
    lscache.set(CACHE_KEY_SORT, !this.state.sortByFrequency)
  }
  getMaxCount () {
    let max = 0
    for (let top of this.state.groups.graph) {
      for (let group of top.groups) {
        for (let keyword of group.keywords) {
          if (keyword.doc_count > max) {
            max = keyword.doc_count
          }
        }
      }
    }
    return max
  }
  sortKeywords = (a, b) => {
    if (this.props.albumID && this.state.sortByFrequency && typeof a === 'object' && typeof b === 'object') {
      return b.doc_count - a.doc_count
    }
    // Nodes with no custom sort will have an index ending in "999"
    // so we can sort alphabetically if this is the case
    a = /999$/.test(a.index) ? a.key : a.index
    b = /999$/.test(b.index) ? b.key : b.index
    return b > a ? -1 : 1
  }
  renderTopGroup = (group, groupIndex) => {
    const maxCount = this.getMaxCount()
    let groups = group.groups.map((group, index) => this.renderGroup(group, index, groupIndex, maxCount))
    if (this.props.imageID) {
      const keywords = group.groups.reduce((keywords, group) => keywords.concat(group.keywords), [])
      groups = this.renderGroup({ keywords }, 0, groupIndex)
    }
    return [
      <dt key='dt'>{group.title || group.name}</dt>,
      <dd key='dd'>
        {groups}
      </dd>
    ]
  }
  renderGroup = (group, index, groupIndex, maxCount) => {
    if (!group.keywords || group.keywords.length === 0) {
      return null
    }
    const [r, g, b] = COLORS[groupIndex % COLORS.length]
    return (
      <div key={index}>
        {group.title &&
          <dt>{group.title}</dt>
        }
        <KeywordList
          key={index}
          keywords={group.keywords.sort(this.sortKeywords)}
          maxCount={maxCount}
          r={r} g={g} b={b}
        />
      </div>
    )
  }
  render () {
    const { groups, error } = this.state
    if (error) {
      return (
        <ErrorMessage
          message='The keyword data could not be loaded'
          onRetry={this.fetchGroups}
        />
      )
    }
    if (!groups) {
      return <LoadingSpinner />
    }
    return (
      <div>
        {this.props.albumID &&
          <button onClick={this.toggleSort} style={{ marginBottom: '20px', fontSize: '13px' }}>
            Alphabetical <Toggle value={this.state.sortByFrequency} /> Most Frequent
          </button>
        }
        {groups.graph.map(this.renderTopGroup)}
      </div>
    )
  }
}

const mapStateToProps = ({ auth }, { albumID, imageID }) => ({
  fetchGroups: () => fetch(ENDPOINT_KEYWORD_GRAPH, {
    query: {
      grouped: 1,
      album_id: albumID,
      image_id: imageID
    },
    token: auth.token
  })
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(GroupedKeywords)



// WEBPACK FOOTER //
// ./src/components/GroupedKeywords.js